import React, { useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Text, TextTypes } from '../../components/index';
import CardDesktop from '../../components/card-detail/recipient/card-desktop';
import CardMobile from '../../components/card-detail/recipient/card-mobile';
import './card-detail.scss';
import JsBarcode from 'jsbarcode';

interface PrintCardProps {
    history: any;
}

const JSBARCODE_OPTIONS = {
    format: 'code128',
    height: 90,
    width: 2,
    textMargin: 2,
    displayValue: true,
    fontSize: 24,
};

function PrintCard({ history }: PrintCardProps) {
    const { state: card } = history.location;

    useEffect(() => {
        card && JsBarcode('#barcode', card.giftcardnumber, JSBARCODE_OPTIONS);
    }, []);

    if (!card) {
        history.push('/');
        return null;
    }

    return (
        <Container fluid className="order print-card">
            <Row className="group-md d-none d-md-flex">
                <Col className="align-self-center">
                    <Text type={TextTypes.H2} className="group-name">
                        {card.group.groupname}
                    </Text>
                    <div className="group-logo">
                        <img alt="group logo" src={card.group.grouplogo} />
                    </div>
                </Col>
            </Row>
            <Row className="group-sm d-md-none d-sm-flex">
                <Col style={{ textAlign: 'center' }}>
                    <img alt="group logo" src={card.group.grouplogo} className="group-logo" />
                    <Text type={TextTypes.H3}>{card.group.groupname}</Text>
                </Col>
            </Row>
            <Row style={{ textAlign: 'center' }}>
                <Col className="d-none d-md-block">
                    <Text type={TextTypes.SUB1}>
                        A gift has been purchased for you from {card.sendername}
                    </Text>
                </Col>
                <Col className="d-md-none d-sm-block">
                    <Text type={TextTypes.P}>
                        A gift has been purchased for you from {card.sendername}
                    </Text>
                    <img id="barcode" />
                </Col>
            </Row>
            <Row className="order-md d-none d-md-flex">
                <Col style={{ padding: '20px 50px' }}>
                    <CardDesktop card={card} />
                </Col>
            </Row>
            <Row className="d-none d-md-flex justify-content-center">
                <img id="barcode" />
            </Row>
            <Row className="order-sm d-md-none d-sm-flex">
                <Col>
                    <CardMobile card={card} />
                </Col>
            </Row>
        </Container>
    );
}

export default PrintCard;
